export const GrowthIconMobile = () => (
  <svg
    width="357"
    height="190"
    viewBox="0 0 357 190"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="26.0538"
      height="77.7795"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 216.699 56.8018)"
      fill="url(#paint0_linear_2345:11963)"
      fill-opacity="0.26"
    />
    <path
      d="M79.1996 12.7141L79.2003 139.72C79.2004 151.239 69.8964 160.595 58.3773 160.66L0.889995 160.983M295.97 174.597L164.091 175.338C152.526 175.403 143.098 166.081 143.033 154.516L142.87 125.382C142.805 113.817 152.128 104.389 163.693 104.324L290.598 103.611C302.163 103.546 311.59 112.868 311.655 124.433L311.669 126.841C311.734 138.406 321.161 147.729 332.726 147.664L347.813 147.579C358.988 147.516 368.099 156.525 368.161 167.7V167.7C368.224 178.876 359.215 187.986 348.039 188.049L324.178 188.183M384.595 115.3L362.958 115.422C351.393 115.487 341.966 106.164 341.901 94.5995L341.874 89.9003C341.81 78.3355 332.382 69.013 320.817 69.078L246.026 69.4985C237.592 69.5459 230.716 62.7469 230.669 54.3125V54.3125C230.621 45.878 237.42 39.0022 245.855 38.9548L349.531 38.3719C354.381 38.3447 358.334 42.2541 358.362 47.1039V47.1039C358.389 51.9537 362.342 55.8631 367.192 55.8358L384.261 55.7399M189.698 69.8151L178.706 69.8769C167.141 69.9419 157.713 60.6194 157.649 49.0546L157.477 18.3811C157.426 9.35333 150.067 2.07597 141.039 2.12672V2.12672C132.011 2.17747 124.733 9.5371 124.784 18.5649L125.322 114.553C125.383 125.47 116.582 134.37 105.665 134.431V134.431M52.4434 25.7474L52.4443 119.61C52.4444 127.974 45.6883 134.769 37.3237 134.816V134.816C28.8926 134.863 22.0327 128.041 22.0327 119.61L22.0324 2.03435"
      stroke="url(#paint1_linear_2345:11963)"
      stroke-opacity="0.3"
      stroke-width="0.7175"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M202.318 49.9358L157.845 95.1051L140.502 77.8808L109.462 109.407L96.595 96.6283L140.358 52.1788L157.702 69.403L189.45 37.1569L202.246 37.0847L202.318 49.9358Z"
      fill="url(#paint2_linear_2345:11963)"
    />
    <path
      d="M201.949 160.448L165.327 160.995C153.222 161.063 137.143 146.263 150.548 126.737L177.24 87.1377L166.741 71.4727L202.818 71.2693L192.495 87.0517L218.407 123.814C229.596 141.507 221.118 160.279 201.949 160.448Z"
      fill="url(#paint3_linear_2345:11963)"
    />
    <path
      d="M193.542 84.8642L176.576 84.9598C175.13 84.968 173.964 86.1523 173.972 87.6051C173.98 89.0579 175.159 90.229 176.606 90.2209L193.571 90.1252C195.017 90.1171 196.183 88.9327 196.175 87.48C196.167 86.0272 194.988 84.8561 193.542 84.8642Z"
      fill="url(#paint4_linear_2345:11963)"
    />
    <path
      d="M185.405 147.269C195.04 147.215 202.806 139.327 202.752 129.651C202.698 119.975 194.844 112.175 185.21 112.23C175.576 112.284 167.809 120.172 167.864 129.848C167.918 139.524 175.771 147.324 185.405 147.269Z"
      fill="url(#paint5_linear_2345:11963)"
    />
    <path
      d="M180.637 124.009L185.457 123.982C185.895 123.98 186.329 124.064 186.734 124.23C187.14 124.396 187.508 124.641 187.819 124.951C188.13 125.26 188.377 125.628 188.546 126.034C188.715 126.439 188.803 126.874 188.804 127.314V127.314C188.808 128.2 188.462 129.052 187.842 129.682C187.221 130.312 186.377 130.669 185.495 130.675L180.674 130.702L188.858 137.057"
      stroke="black"
      stroke-width="1.45109"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M180.664 127.274L189.936 127.222"
      stroke="black"
      stroke-width="1.45109"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M180.637 124.009L189.909 123.957"
      stroke="black"
      stroke-width="1.45109"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M236.16 89.108C237.431 89.532 238.803 88.8408 239.225 87.5642C239.648 86.2875 238.959 84.9089 237.688 84.485C236.417 84.061 235.045 84.7522 234.622 86.0288C234.2 87.3054 234.888 88.684 236.16 89.108Z"
      stroke="#726BF5"
      stroke-width="0.282978"
    />
    <path
      d="M157.062 43.6078C158.077 43.9463 159.173 43.3945 159.51 42.3755C159.847 41.3564 159.297 40.2559 158.283 39.9175C157.268 39.579 156.172 40.1308 155.835 41.1499C155.498 42.1689 156.048 43.2694 157.062 43.6078Z"
      fill="#FEC8F4"
    />
    <path
      d="M135.816 113.135C136.831 113.473 137.927 112.921 138.263 111.902C138.6 110.883 138.051 109.783 137.036 109.444C136.022 109.106 134.926 109.658 134.589 110.677C134.252 111.696 134.801 112.796 135.816 113.135Z"
      fill="url(#paint6_linear_2345:11963)"
    />
    <path
      d="M260.853 36.7911L258.538 36.776C258.111 36.7732 257.763 37.1181 257.761 37.5462L257.746 39.872C257.743 40.3001 258.086 40.6495 258.512 40.6523L260.828 40.6673C261.254 40.6701 261.602 40.3253 261.605 39.8971L261.62 37.5714C261.623 37.1432 261.28 36.7939 260.853 36.7911Z"
      fill="#FEDD7E"
    />
    <ellipse
      rx="13.0269"
      ry="13.0834"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 230.166 134.469)"
      fill="url(#paint7_linear_2345:11963)"
    />
    <ellipse
      rx="10.1088"
      ry="10.1527"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 230.165 134.468)"
      stroke="black"
      stroke-width="0.317467"
    />
    <rect
      width="28.4795"
      height="10.2821"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 129.809 150.912)"
      fill="url(#paint8_linear_2345:11963)"
    />
    <rect
      width="28.4795"
      height="10.2821"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 123.562 140.668)"
      fill="url(#paint9_linear_2345:11963)"
    />
    <rect
      width="28.4795"
      height="10.2821"
      transform="matrix(0.999984 -0.0056368 0.0055882 0.999984 127.652 130.398)"
      fill="url(#paint10_linear_2345:11963)"
    />
    <path
      d="M127.773 140.643L152.042 140.506"
      stroke="black"
      stroke-width="0.317467"
    />
    <path
      d="M129.809 150.912L152.104 150.786"
      stroke="black"
      stroke-width="0.317467"
    />
    <path
      d="M110.906 161.543L221.396 160.92"
      stroke="black"
      stroke-width="0.317467"
    />
    <path
      d="M226.234 160.892L229.64 160.873"
      stroke="black"
      stroke-width="0.317467"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2345:11963"
        x1="16.0937"
        y1="85.2339"
        x2="16.0937"
        y2="15.3558"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2345:11963"
        x1="314.07"
        y1="-218.348"
        x2="154.446"
        y2="179.1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9094FF" />
        <stop offset="0.625" stop-color="#989CFD" stop-opacity="0.375" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2345:11963"
        x1="207.63"
        y1="23.227"
        x2="106.09"
        y2="116.308"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#7C6FF5" />
        <stop offset="1" stop-color="#7C6FF5" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2345:11963"
        x1="206.603"
        y1="149.569"
        x2="97.8974"
        y2="154.259"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A4EFC9" />
        <stop offset="1" stop-color="#A4EFC9" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2345:11963"
        x1="198.195"
        y1="81.0321"
        x2="164.259"
        y2="106.024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#726BF5" />
        <stop offset="1" stop-color="#726BF5" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2345:11963"
        x1="198.08"
        y1="112.532"
        x2="174.875"
        y2="147.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2345:11963"
        x1="139.298"
        y1="109.41"
        x2="133.66"
        y2="110.724"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#655CFF" />
        <stop offset="1" stop-color="#655CFF" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2345:11963"
        x1="24.7712"
        y1="3.58846"
        x2="3.49916"
        y2="28.5587"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2345:11963"
        x1="28.4795"
        y1="9.28147"
        x2="-13.2684"
        y2="-6.42556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2345:11963"
        x1="28.4795"
        y1="9.28147"
        x2="-13.2684"
        y2="-6.42556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2345:11963"
        x1="28.4795"
        y1="9.28147"
        x2="-13.2684"
        y2="-6.42556"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFED46" />
        <stop offset="1" stop-color="#FFED46" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);



// WEBPACK FOOTER //
// ./components/homePageNew/growthSection/icon/growthIconMobile.tsx